export const RED = 'rgba(209, 102, 102, 0.9)';
export const GREEN = 'rgba(4, 167, 119, 0.9)';
export const BLUE = 'rgba(77, 126, 168, 0.9)';
export const GREY = 'rgba(27, 25, 25, 0.3)';
